export { default } from "./SubScore";
